import { InfoRounded } from "@mui/icons-material";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "src/store";
import { DVA_EVENTS, resolveDvaNote } from "src/utils/dvaInterceptor";

// Puente global: escucha el interceptor de axios para pedir el mensaje
// requerido por una política DVA y para avisar cuando una acción quedó
// encolada, sin tener que tocar cada formulario individualmente.
const DvaInterceptorHost = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentCustomer } = useSelector((state) => state.customers);
  const [noteRequest, setNoteRequest] = useState(null);
  const [noteValue, setNoteValue] = useState("");
  const [pendingNotice, setPendingNotice] = useState(null);

  useEffect(() => {
    const onNoteRequest = (event) => {
      setNoteValue("");
      setNoteRequest(event.detail);
    };
    const onPendingNotice = (event) => {
      setPendingNotice(event.detail);
    };

    window.addEventListener(DVA_EVENTS.NOTE_REQUEST, onNoteRequest);
    window.addEventListener(DVA_EVENTS.PENDING_NOTICE, onPendingNotice);
    return () => {
      window.removeEventListener(DVA_EVENTS.NOTE_REQUEST, onNoteRequest);
      window.removeEventListener(DVA_EVENTS.PENDING_NOTICE, onPendingNotice);
    };
  }, []);

  const closeNoteDialog = (note) => {
    if (!noteRequest) return;
    resolveDvaNote(noteRequest.id, note);
    setNoteRequest(null);
  };

  const handleViewRequest = () => {
    if (!pendingNotice?.request_id || !currentCustomer?.shortname) return;
    navigate(
      `/${currentCustomer.shortname}/approval/detail/${pendingNotice.request_id}`,
    );
    setPendingNotice(null);
  };

  return (
    <>
      <Dialog
        open={Boolean(noteRequest)}
        onClose={() => closeNoteDialog(null)}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: (theme) => theme.zIndex.modal + 100 }}
      >
        <DialogTitle>{t("Mensaje requerido para DVA")}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            {t(
              "Esta acción requiere doble validación administrativa. Indique un mensaje breve para el aprobador antes de continuar.",
            )}
          </DialogContentText>
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            label={t("Mensaje para el aprobador")}
            value={noteValue}
            onChange={(e) => setNoteValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeNoteDialog(null)}>{t("Cancelar")}</Button>
          <Button
            variant="contained"
            disabled={!noteValue.trim()}
            onClick={() => closeNoteDialog(noteValue.trim())}
          >
            {t("Enviar a DVA")}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={Boolean(pendingNotice)}
        autoHideDuration={10000}
        onClose={() => setPendingNotice(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="info"
          icon={<InfoRounded />}
          onClose={() => setPendingNotice(null)}
          action={
            pendingNotice?.request_id ? (
              <Button color="inherit" size="small" onClick={handleViewRequest}>
                {t("Ver solicitud")}
              </Button>
            ) : undefined
          }
        >
          {t(
            "La acción fue enviada a Doble Validación Administrativa (DVA #{{id}}) y quedó pendiente de aprobación.",
            { id: pendingNotice?.request_id },
          )}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DvaInterceptorHost;
